// extracted by mini-css-extract-plugin
export default {"SharedMarkdownContent":"DirectoryRichtextContent-module__SharedMarkdownContent__aH1R11y"};